import styled, { css } from 'styled-components';

import variables from '../../../styles/variables';

interface Props {
  readonly visible: boolean;
}

export const BackToTopWrapper = styled.div`
  text-align: center;
`;

export const ScrollUpButton = styled.button<Props>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  padding: 0.75rem;
  transition: all 0.5s;
  background-color: ${variables.colorWhite};
  border: none;
  border-radius: 0.3rem 0 0 0.3rem;
  bottom: 25%;
  z-index: 500;
  /* Right -(size of button) to hide it completely off screen */
  right: -100px;
  max-width: 90px;
  box-shadow: 0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 768px) {
    bottom: 15%;
  }
  &:hover {
    background-color: ${variables.colorBlack};
    p {
      color: ${variables.colorWhite};
    }
  }

  p {
    color: ${variables.colorRed};
    clear: both;
    text-align: center;
    position: relative;
    font-size: 1rem;
    padding: 0;
    margin-bottom: 0;
    transition: all 0.5s;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
    }
  }

  ${({ visible }) => visible
    && css`
      right: 0;
      transition: all 0.5s;
    `};

  .backUpArrow {
    margin: 0 0 0.5rem;
    text-align: center;

    @media screen and (max-width: 768px) {
      width: 2rem;
    }
  }
`;
